import React from "react";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";

/**
 * Top-level providers composed in one place so the router stays clean.
 * Add future providers (QueryClientProvider, ThemeProvider) here.
 */
export function AppProviders({ children }) {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors closeButton />
      {children}
    </AuthProvider>
  );
}
